const people = {
  "Наталія Біндюк": {
    img: "../assets/aboutUs/people/bindiuk.jpg",
    text: "голова та ініціаторка створення громадської організації «Жінки в громаді»",
  },
  "Юлія Люкшин": {
    img: "../assets/aboutUs/people/lukshyn.jpg",
    text: "секретар ГО “Жінки в громаді”",
  },
  "Тетяна Куць": {
    img: "../assets/aboutUs/people/kuts.jpg",
    text: "директорка Здолбунівського ліцею № 4. Стихія – математика та інформатика",
  },
  "Бойко Вікторія": {
    img: "../assets/aboutUs/people/boyko.jpg",
    text: "начальник відділу бухгалтерського обліку та контролю, головний бухгалтер Здолбунівської міської ради",
  },
  "Ковальчук Людмила": {
    img: "../assets/aboutUs/people/kovalchuk.jpg",
    text: "головний спеціаліст відділу бухгалтерського обліку та контролю Здолбунівської міської ради",
  },
  "Ольга Якута": {
    img: "../assets/aboutUs/people/yakuta.jpg",
    text: "старший викладач кафедри екології, географії та хімії Рівненського державного гуманітарного університету",
  },
  "Руслана Мичка": {
    img: "../assets/aboutUs/people/mytska.jpg",
    text: "голова Здолбунівської міської організації Українського Червоного Хреста",
  },
  "Вікторія Янко": {
    img: "../assets/aboutUs/people/yanko.jpg",
    text: "директорка Новомильського ЗДО «Барвінок»",
  },
  "Жанна Кадлубіцька": {
    img: "../assets/aboutUs/people/kadlubitska.jpg",
    text: "директорка Здолбунівського закладу дошкільної освіти (ясла-садок) N5 «Усмішка»",
  },
  "Оксана Корольова": {
    img: "../assets/aboutUs/people/korolova.jpg",
    text: "В.о. директора Здолбунівського закладу дошкільної освіти «Дзвіночок»",
  },
  "Валентина Теребійчук": {
    img: "../assets/aboutUs/people/terebiychuk.jpg",
    text: "директорка Здолбунівського центру культури і дозвілля",
  },
  "Ольга Болотнюк": {
    img: "../assets/aboutUs/people/bolotnyk.jpg",
    text: "приватний підприємець, власниця магазину-пекарні Bulki",
  },
  "Світлана Жовтанюк": {
    img: "../assets/aboutUs/people/zovtanyk.jpg",
    text: "начальник відділу обслуговування громадян Головного управління пенсійного фонду України в Рівненській області",
  },
  "Валентина Капітула": {
    img: "../assets/aboutUs/people/kapitula.jpg",
    text: "секретар Здолбунівської міської ради",
  },
};

export { people };
